import {Group, rem, Text, TextProps} from "@mantine/core";
import {InsightContainer, InsightContainerProps} from "../InsightContainer/InsightContainer";
import {FormattedQuantity} from "../../text/FormattedQuantity/FormattedQuantity";
import {useTranslation} from "react-i18next";
import {PropsWithChildren, useMemo} from "react";
import {StatisticsType} from "@ots-frontend/ots-data";

export type InsightTextProps = TextProps & {
  type?: StatisticsType,
  value?: number
  formatOptions?: Intl.NumberFormatOptions
}

export const InsightText = (props: InsightTextProps) => {
  const {
    type,
    value,
    size = rem(24),
    fw = 700,
    lh = 1,
    ...rest
  } = props

  const {t} = useTranslation(["common"])

  const formatOptions : Intl.NumberFormatOptions | undefined = useMemo(() => {
    return type?.unitType === 'currency' ? {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    } : undefined
  }, [type])

  return (
    <Text {...rest} size={size} fw={fw} lh={lh}>
      <FormattedQuantity
        value={{number: value}}
        options={formatOptions}
        defaultValue={t<string>('common.shared.notapplicable', "N/A")}/>
    </Text>
  )
}

export type InsightProps = Omit<InsightContainerProps, 'children'> & Pick<TextProps, 'color'> & {
  value?: number
  formatOptions?: Intl.NumberFormatOptions
}

export const Insight = (props: PropsWithChildren<InsightProps>) => {
  const {
    value,
    formatOptions,
    color,
    children,
    ...rest
  } = props

  return (
    <InsightContainer {...rest}>
      <Group align="flex-end" spacing="xs" mt={25}>
        <InsightText
          value={value}
          formatOptions={formatOptions}
          color={color}/>
      </Group>
      {children}
    </InsightContainer>
  );
}
